import React from 'react';
import { TableCell, TableHead, TableRow, TableSortLabel, Tooltip, Typography } from '@material-ui/core';
// TODO fix the api's def of a "readable job"
const rows = [
	{
		id: 'id',
		align: 'right',
		disablePadding: false,
		label: 'ID',
		sort: true
	},
	{
		id: 'name',
		align: 'left',
		disablePadding: false,
		label: 'Name',
		sort: true
	},
	{
		id: 'state',
		align: 'left',
		disablePadding: false,
		label: 'State',
		sort: true
	},
	{
		id: 'submitted',
		align: 'left',
		disablePadding: false,
		label: 'Submitted',
		sort: true
	},
	{
		id: 'cores',
		align: 'center',
		disablePadding: false,
		label: 'Cores',
		sort: true
	},
	{
		id: 'nodes',
		align: 'center',
		disablePadding: false,
		label: 'Nodes',
		sort: true
	}
];

const QueueTableHead = props => {
	const createSortHandler = property => event => {
		props.onRequestSort(event, property);
	};

	return (
		<TableHead>
			<TableRow className="h-64">
				{rows.map(row => {
					return (
						<TableCell
							key={row.id}
							id={row.id}
							align={row.align}
							padding={row.disablePadding ? 'none' : 'normal'}
							sortDirection={props.order.id === row.id ? props.order.direction : false}
						>
							{row.sort && (
								<Tooltip
									title="Sort"
									placement={row.align === 'right' ? 'bottom-end' : 'bottom-start'}
									enterDelay={300}
								>
									<TableSortLabel
										id={`table-header-${row.id}`}
										active={props.order.id === row.id}
										direction={props.order.direction}
										onClick={createSortHandler(row.id)}
									>
										<Typography className="font-bold">{row.label}</Typography>
									</TableSortLabel>
								</Tooltip>
							)}
						</TableCell>
					);
				}, this)}
				<TableCell 
					id="queue_table_head_actions" 
					align="center" 
					padding="normal"
					style={{ 
						position: 'sticky',
						right: 0,
						backgroundColor: '#fafafa',
						zIndex: 2
					}}
				>
					<Typography className="font-bold"> Actions</Typography>
				</TableCell>
			</TableRow>
		</TableHead>
	);
};

export default QueueTableHead;
